<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/businessIntranet/findBusinessOrderList.action"
                    ref="intranetBusinessOrderManagementTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-select @change="search()" v-model="queryParams.payStatus" :clearable="true" :filterable="true">
                <el-option :value="1" label="待支付"></el-option>
                <el-option :value="2" label="支付成功"></el-option>
                <el-option :value="3" label="支付失败"></el-option>
                <el-option :value="4" label="支付关闭"></el-option>
                <el-option :value="5" label="转入退款"></el-option>
                <el-option :value="6" label="取消支付"></el-option>
                <el-option :value="7" label="支付中"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select @change="search()" v-model="queryParams.payType" :clearable="true" :filterable="true">
                <el-option :value="1" label="线上支付"></el-option>
                <el-option :value="2" label="线下充值"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select  @change="search()" clearable placeholder="商品类型"
                          v-model="queryParams.goodType">
                <el-option :value="6" label="卖车通会员"></el-option>
                <el-option :value="4" label="买卖通会员"></el-option>
                <el-option :value="8" label="专享通会员"></el-option>
                <el-option :value="5" label="购买车商群"></el-option>
                <el-option :value="9" label="二手车置顶"></el-option>
                <el-option :value="10" label="朋友圈置顶"></el-option>
                <el-option :value="11" label="求购置顶"></el-option>
                <el-option :value="12" label="充值权益"></el-option>
                <el-option :value="13" label="充值人脉"></el-option>
                <el-option :value="14" label="充值推广通"></el-option>
                <el-option :value="15" label="充值保证金"></el-option>
                <el-option :value="16" label="退款保证金"></el-option>
                <el-option :value="17" label="私信推广"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item >
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="创建结束日期"
                  range-separator="至"
                  start-placeholder="创建开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="搜索姓名/手机号/商家名称" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="search()" type="primary">搜索</el-button>
            </el-form-item>
            <el-form-item v-permissions="'exportIntranetBus'">
              <el-button @click="excelExport()">导出</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <row>
          <el-col>
            <div style=" height: 40px;margin-bottom: -10px;margin-top: -5px;font-size: 22px;color: red;">
              本月营收：{{moneyData.monthMoney/100}}元&nbsp;&nbsp;今日营收：{{moneyData.todayMoney/100}}元&nbsp;&nbsp; 昨日营收：{{moneyData.yestodayMoney/100}} 元&nbsp;&nbsp; 当前查询结果营收：{{moneyData.currentMoney/100}} 元
            </div>
          </el-col>
        </row>
      </template>
      <template slot="item">
        <el-table-column
            label="订单号"
            prop="orderNumber">
        </el-table-column>
        <el-table-column
            label="会员信息"
            prop="">
          <template scope="scope">
            {{scope.row.personName}}-{{scope.row.personPhone}}
          </template>
        </el-table-column>
        <el-table-column
            label="商家名称"
            prop="businessName">
        </el-table-column>
        <el-table-column
            label="邀请维护"
            prop="">
          <template scope="scope">
            <p>邀请人：{{scope.row.inviterEmployeeName}}-{{scope.row.inviterEmployeePhone}}</p>
            <p>维护人：{{ scope.row.maintenanceName ? scope.row.maintenanceName : '无' }}</p>
          </template>
        </el-table-column>
        <el-table-column label="商品类型">
          <template scope="scope">
            {{scope.row.goodType|goodTypeFilter}}
          </template>

        </el-table-column>
        <el-table-column
            label="付款金额(元)"
            prop="totalMoney">
        </el-table-column>
        <el-table-column
            label="付款方式"
            prop="payType">
          <template scope="scope">
            <p> {{scope.row.payType|payTypeFilter}}</p>
          </template>
        </el-table-column>
        <el-table-column
            label="支付状态"
           >
          <template scope="scope">
           <p> {{scope.row.payStatus|payStatusFilter}}</p>
           <p> {{scope.row.payTime|dateTimeFormat}}</p>
          </template>
        </el-table-column>
      <el-table-column label="收款业务员" prop="collectionClerk">
        <template scope="scope">
          <p> {{scope.row.collectionClerk}}</p>
          <el-button type="text" @click="editNote(scope.row.id)">{{ scope.row.collectionClerk ? '修改备注' : '修改备注' }}
          </el-button>
            <el-button type="text" @click="editMoney(scope.row.id)">修改金额</el-button>
        </template>
      </el-table-column>
        <el-table-column
            label="创建时间">
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
import Config from '@/framework/configs/Config'
export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetBusinessOrderManagement',
  data: function () {
    return {
      queryParams: {
        payStatus: 2,
        payType: null,
        memberType: null
      },
      moneyData: {

      }
    }
  },
  created: function () {
    this.loadData()
  },
  methods: {
    excelExport: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }

      let url = Config.baseUrl + '/businessIntranet/exportBusinessOrderList.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath
      if (this.queryParams.payStatus) {
        url = url + '&payStatus=' + this.queryParams.payStatus
      }
      if (this.queryParams.payType) {
        url = url + '&payType=' + this.queryParams.payType
      }
      if (this.queryParams.keyword) {
        url = url + '&keyword=' + this.queryParams.keyword
      }
      if (this.queryParams.startTime) {
        url = url + '&startTime=' + this.queryParams.startTime
      }
      if (this.queryParams.endTime) {
        url = url + '&endTime=' + this.queryParams.endTime
      }

      if (this.queryParams.goodType) {
        url = url + '&goodType=' + this.queryParams.goodType
      }
      window.open(url)
    },
    editNote: function (id) {
      let _this = this

      this.$prompt('请输入付款备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        if (!value) {
          this.$message({
            type: 'info',
            message: '备注不能为空！ '
          })

          return
        }

        let params = {
          id: id,
          collectionClerk: value
        }

        let listener = {
          success: function () {
            _this.$message({
              type: 'success',
              message: '操作成功！ '
            })
            _this.search()
          }
        }

        BasicModel.post(this, 'businessIntranet/editOrderNote.action', params, listener)
      })
    },
    editMoney: function (id) {
      let _this = this

      this.$prompt('请输入订单金额【元】', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        if (!value) {
          this.$message({
            type: 'info',
            message: '订单金额【元】不能为空！ '
          })
          return
        }

        var exp = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/
        if (!exp.test(value)) {
          this.$message({
            type: 'info',
            message: '订单金额【元】不规范！ '
          })
          return
        }

        let params = {
          id: id,
          totalMoney: value
        }

        let listener = {
          success: function () {
            _this.$message({
              type: 'success',
              message: '操作成功！ '
            })
            _this.search()
          }
        }

        BasicModel.post(this, 'businessIntranet/editOrderMoney.action', params, listener)
      })
    },

    search: function () {
      this.$refs.intranetBusinessOrderManagementTable.search()
      this.loadData()
    },
    loadData () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            _this.moneyData = dataInfo.datas
          } else {
            _this.moneyData.currentMoney = 0
            _this.moneyData.monthMoney = 0
            _this.moneyData.yestodayMoney = 0
            _this.moneyData.todayMoney = 0
          }
        }
      }
      BasicModel.get(this, 'businessIntranet/selectBusinessOrderStatic.action', this.queryParams, listener)
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.search()
    }
  },
  filters: {
    payStatusFilter: function (value) {
      // 1-待支付；2-支付成功;3-支付失败;4-支付关闭;5-转入退款;6-取消支付;7-支付中
      let str = ''
      switch (value) {
        case 1:
          str = '待支付'
          break
        case 2:
          str = '支付成功'
          break
        case 3:
          str = '支付失败'
          break
        case 4:
          str = '支付关闭'
          break
        case 5:
          str = '转入退款'
          break
        case 6:
          str = '取消支付'
          break
        case 7:
          str = '支付中'
          break
        default:
          str = '无'
      }
      return str
    },
    payTypeFilter: function (val) {
      let str = ''
      switch (val) {
        case 1:
          str = '线上支付'
          break
        case 2:
          str = '线下支付'
          break
        default:
          str = '无'
      }
      return str
    },
    goodTypeFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '卖车通365会员'
          break
        case 6:
          str = '卖车通会员'
          break
        case 7:
          str = '收车通会员'
          break
        case 4:
          str = '买卖通会员'
          break
        case 8:
          str = '专享通会员'
          break
        case 5:
          str = '购买车商群'
          break
        case 9:
          str = '二手车置顶'
          break
        case 10:
          str = '朋友圈置顶'
          break
        case 11:
          str = '求购置顶'
          break
        case 12:
          str = '充值权益'
          break
        case 13:
          str = '充值人脉'
          break
        case 14:
          str = '充值推广通'
          break
        case 15:
          str = '充值保证金'
          break
        case 16:
          str = '退款保证金'
          break
        case 17:
          str = '私信推广'
          break
        default:
          str = '无'
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
